import { Fragment, type ReactNode } from 'react';

/**
 * Wrap react element into a fragment keyed by array index
 *
 * Using index as key is discouraged in general, but in some cases (like data from api
 * with no reliable unique key in the example below) there is no other way.
 *
 * @example
 * const dataFromApi = [
 *   {name: 'John', score: 10},
 *   {name: 'Jack', score: 20},
 * ];
 * const renderPerson = data => <p><strong>{data.name}:</strong> {data.score}</p>;
 * return <>
 *   {dataFromApi
 *     .map(renderPerson)
 *     .map(unsafeWrapWithReactKeyByIndex)
 *   }
 * <>;
 *
 */
export const unsafeWrapWithReactKeyByIndex = (
  element: ReactNode,
  index: number,
): ReactNode => <Fragment key={index}>{element}</Fragment>;
